import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ch_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return urlOrPath;
};
